<template>
  <div class="edit-studio-container edit-studio-com">
    <div class="admin-header-container admin-header-sec">
      <div :class="{ 'admin-header': member.id != 'new_studio' }">
        <h1 class="title admin-title-sec" v-if="member.id != 'new_member'">{{ $t('edit-member') + ': ' +
          member.displayFirstName
          +
          " " + member.displayLastName }} </h1>
        <!-- <h1 class="title admin-title-sec" v-if="member.id == 'new_member'">{{ $t('add-member') }} </h1> -->
        <div>
          <!-- <div class="img-container" @click="togglePopup(true, false, true)"> -->
          <div class="img-container">
            <img v-if="member.photo" width="90" :src="originalMemberPhoto" />
            <img v-if="!member.photo && member.id != 'new_member'" width="90"
              :src="fit20.storageBaseUrl + '/member/default.svg'" />
          </div>
          <div class="btn-container">
            <span id="cancelMember" class="fit20-btn cancel-btn-disable" @click="cancelEditing">{{ $t('cancel')
            }}</span>
            <span id="saveMember" class="fit20-btn save-btn-disable" @click="saveMember">{{ $t('save') }}</span>
          </div>
        </div>
      </div>
    </div>
    <main class="tab-content">
      <h2 class="item text-secondary">{{ $t('general-info') }}</h2>
      <form class="form-container admin-studio-tab-pane fade show active" id="admin_studio_info">
        <div class="field-sec">
          <label>{{ $t('first-name') }}</label>
          <input type="text" class="form-control" v-model="member.displayFirstName" disabled />
        </div>
        <div class="field-sec">
          <label>{{ $t('last-name') }}</label>
          <input type="text" class="form-control" v-model="member.displayLastName" disabled />
        </div>
        <div class="field-sec">
          <label class="">{{ $t('date-of-birth') }}</label>
          <input type="date" class="form-control" v-model="member.birthDate" min="1900-01-01" :max="maxDate" disabled />
        </div>
        <div class="field-sec">
          <label for="editedStudio_gatewayIPAddress" class="">{{ $t('gender') }}</label>
          <select id="editedStudio_gatewayIPAddress" class="" v-model="member.gender" disabled>
            <option value="">{{ $t('') }}</option>
            <option value="male">{{ $t('male') }}</option>
            <option value="female">{{ $t('female') }}</option>
            <option value="other">{{ $t('other') }}</option>
          </select>
        </div>
        <div class="field-sec">
          <label class="">{{ $t('email') }}</label>
          <input type="email" class="form-control" v-model="member.email" disabled />
        </div>
        <div class="field-sec">
          <label>{{ $t('phone') }}</label>
          <input type="text" class="form-control" v-model="member.phone" disabled>
        </div>
        <div class="field-sec">
          <label>{{ $t('language') }}</label>
          <select v-model="member.language" disabled>
            <option v-for="language in fit20.languages" :value="language.code" :key="language.code">{{ language.name }}
            </option>
          </select>
        </div>
        <!-- <div class="field-sec">
          <label>{{ $t('status') }}</label>
          <select class="" v-model="member.status">
            <option value="prospect">{{ $t('prospect') }}</option>
            <option value="exProspect">{{ $t('ex-prospect') }}</option>
            <option value="member">{{ $t('member') }}</option>
            <option value="exMember">{{ $t('ex-member') }}</option>
            <option value="onHold">{{ $t('on-hold') }}</option>
          </select>
        </div> -->
        <div class="field-sec measure-div">
          <label>{{ $t('height') }}</label>
          <input type="number" class="form-control" v-model="member.height" disabled>
          <span class="kg">{{ $t("cm") }}</span>
        </div>
        <div class="field-sec measure-div">
          <label>{{ $t('weight') }}</label>
          <input type="number" class="form-control" v-model="lastWeight" disabled>
          <span class="kg">{{ $t("kg") }}</span>
        </div>
        <div class="field-sec">
          <label class="">{{ $t('start-membership') }}</label>
          <input type="date" class="form-control" v-model="member.startMembership" disabled />
        </div>
        <div class="field-sec">
          <label class="">{{ $t('end-membership') }}</label>
          <input type="date" class="form-control" v-model="member.endMembership" disabled />
        </div>
        <div class="fade"></div>
        <AddRemoveItem v-if="member.id != 'new_member'" title="member-in" :data="memberStudios" :selectItem="selectItem"
          :removeItem="removeMemberFromStudio" :togglePopup="togglePopup" :popupParams="[true, true, false]"
          name1="name" name2="" :fit20="fit20"></AddRemoveItem>
        <div class="ex-member-container" v-if="member.id != 'new_member'">
          <h2 class="text-secondary">{{ $t('ex-studios') }} </h2>
          <div class="flex ex-member-flex" v-for="item in exMemberStudios">
            <div class="ex-member-item pointer"> {{ item.name }}</div>
            <img width="50" :src="fit20.storageBaseUrl + '/static/icons/%2B.png'" @click="reactiveStudio(item.id)" />
          </div>
        </div>


      </form>
    </main>
    <div class="popup-overlay" v-if="showStudioPopup">
      <div class="popup-content">
        <div class="flex popup-title">
          <div>{{ $t('ad-studio-2-member') }}</div>
          <div @click="togglePopup"><img :src="fit20.storageBaseUrl + '/static/icons/x.svg'" width="40px" /></div>
        </div>
        <input type="text" @input="openSelectDropdown" @click="openSelectDropdown" v-model="studioFilter"
          :placeholder="$t('placeholder1')" />
        <div v-show="isDropdownOpen" class="dropdown-container">
          <div class="dropdown-options">
            <div v-for="studio in toAddStudios" :key="studio.id" @click="selectAnItem(studio)" class="dropdown-option">
              {{ studio.name }}
            </div>
          </div>
        </div>
        <div class="btn-container">
          <span class="fit20-btn cancel-btn-disable" @click="togglePopup">{{ $t('cancel') }}</span>
          <span class="fit20-btn save-btn-disable" @click="addItem">{{ $t('ok') }}</span>
        </div>
      </div>
    </div>
    <!-- <div class="popup-overlay" v-if="showPhotoPopup">
      <Photo :title="member.firstName" :id="member.id" :changePhoto="changePhoto" :savePhoto="savePhoto"
        :togglePopup="togglePopup" :photo="memberPhoto" :editPhoto="fit20.storageBaseUrl + '/static/icons/%2Bfoto.svg'"
        :togglePopupValues="[false, false, true]" :closeIcon="fit20.storageBaseUrl + '/static/icons/white-x.svg'" />
    </div> -->
  </div>
</template>

<script>
import isEqual from 'lodash/isEqual';
import AddRemoveItem from './AddRemoveItem';
import Photo from '../Photo';
import { isValidEmail } from "../../actions/global.js";
// import Studios from '../Studios.vue';
// import {
//   reactive
// } from 'vue';
export default {
  name: 'Member',
  components: {
    AddRemoveItem,
    Photo
  },
  props: ["user", "selectTab", "admin_fit20", "fit20", "formatDate", "admin"],
  data() {
    return {
      memberStudios: [],
      exMemberStudios: [],
      member: {},
      studios: [],
      toAddStudios: [],
      originalMemberPhoto: false,
      originalMember: {},
      updated: false,
      maxDate: this.formatDate(new Date()),
      originalStudios: [],
      showPhotoPopup: false,
      showStudioPopup: false,
      studioFilter: "",
      isFilter: false,
      isDropdownOpen: false,
      lastWeight: "",
      newWeight: {
        date: new Date(),
        weight: 0,
      },
      selectedItem: "",
      // defaultStudioPhoto: "https://storage.googleapis.com/fit20app-4-acctest.appspot.com/mebmer/defult.svg",
      memberPhoto: "",
      newPhoto: false,
      // originalMemberPhoto: "http://storage.googleapis.com/fit20app-4-acctest.appspot.com/member/defult.svg",

    };
  },
  methods: {
    // isValidEmail: function (email) {
    //   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    //   return emailRegex.test(email);
    // },

    selectTrainer: function () {
      console.log("should go to selected item");
    },
    selectItem: function (id) {
      if (confirm(this.$t('make-main-studio'))) {
        this.studios.forEach(studio => {
          if (studio.id == id) {
            studio.main = true;
          } else {
            studio.main = false;
          }
        })
      }
      console.log("should go to selected item");
    },
    saveMember: async function () {
      if (isEqual(this.member, this.originalMember) && (this.lastWeight == 0 || (this.member.measure.length > 0 && this.lastWeight == this.member.measure[this.member.measure.length - 1].weight))) {
        alert(this.$t('general-no-changes'));
      } else if (!this.member.firstName) {
        alert(this.$t('required-field').replace('{field}', this.$t('first-name')));
      } else if (this.member.email && this.member.email.length > 0 && !isValidEmail(this.member.email)) {
        alert(this.$t('invalid-email'));
      } else {
        if (this.member.id == "new_member") {
          this.member.id = false;
        }
        // we need to add the new weight if we have new one !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
        if (this.member.measure.length > 0 && this.lastWeight != this.member.measure[this.member.measure.length - 1].weight) {

          this.member.measure.push({
            date: new Date().toISOString(),
            weight: this.lastWeight
          })
        }
        this.member.studios = [...this.studios];

        let updateMember = await fetch(this.fit20.baseUrl + "/api/members/" + this.fit20.user.email + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(this.member),
        });
        let updatedMember = await updateMember.json();
        this.admin_fit20.member = JSON.parse(JSON.stringify(updatedMember));

        let existMember = this.admin_fit20.members.find(item => item.id == updatedMember.id);
        if (existMember) {
          console.log("exist member");
          existMember = updatedMember;
        } else {
          this.admin_fit20.members = [...this.admin_fit20.members, updatedMember];
        }
        // this.originalMember = updatedMember;
        this.admin_fit20.studio = '';
        this.updated = true;
      }
    },
    cancelEditing: function () {
      if (!isEqual(this.member, this.originalMember)) {
        this.admin_fit20.member = {
          ...this.originalMember
        };
        this.updated = true;
      }
    },
    // removeUserFromStudio: function (userId) {
    //   this.studio.users = this.studio.users.filter(user => user.id != userId);
    // },
    reactiveStudio: function (studioId) {
      const studioIndex = this.studios.findIndex(studio => studio.id == studioId);
      if (studioIndex !== -1) {
        let mainStudio = this.studios.find(studio => !studio.memberStatus.includes('ex') && studio.main);
        if (mainStudio) {
          console.log('set false');
          this.$set(this.studios[studioIndex], 'main', false);
        } else {
          console.log('set true');
          this.$set(this.studios[studioIndex], 'main', true);
        }
        this.$set(this.studios[studioIndex], 'memberStatus', 'member');



        // let ifMainStudio = this.studios.find(studio => studio.main);
        // console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>");
        // console.log(this.studios);
        // console.log(ifMainStudio);
        // console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>");
        // if (!ifMainStudio) {
        //   console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>");
        //   console.log('set true');
        //   this.$set(this.studios[studioIndex], 'main', true);
        // } else {
        //   // console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>");
        //   // console.log('set false');
        //   // this.$set(this.studios[studioIndex], 'main', false);
        // }
      }
    },
    removeMemberFromStudio: function (studioId) {
      console.log("reomve");

      const studioIndex = this.studios.findIndex(studio => studio.id == studioId);

      if (studioIndex !== -1) {
        if (this.studios[studioIndex].main) {
          if (window.confirm(this.$t("main-studio-err"))) {
            this.$set(this.studios[studioIndex], 'memberStatus', 'exMember');
            this.$set(this.studios[studioIndex], 'main', false);

          }
        } else {
          this.$set(this.studios[studioIndex], 'memberStatus', 'exMember');
          this.$set(this.studios[studioIndex], 'main', false);

        }
      }
    },
    addItem: function () {
      let mainStudio = false;
      if (this.studios && this.studios.length > 0) {
        let ifMainStudio = this.studios.find(studio => studio.main);
        let settingsId;
        if (!ifMainStudio) {
          mainStudio = true;
          if (this.member.machinesSettings && this.member.machinesSettings.length > 0) {
            settingsId = this.member.machinesSettings[0].studioId;
          }
        } else {
          settingsId = ifMainStudio.id
        }
        let mainStudioSettings = this.member.machinesSettings.filter(item => item.studioId == settingsId);
        if (mainStudioSettings && mainStudioSettings.length > 0) {
          mainStudioSettings.forEach(setting => {
            //setting.studioId = this.selectedItem.id;
            let newSetting = JSON.parse(JSON.stringify(setting));
            newSetting.studioId = this.selectedItem.id;
            this.member.machinesSettings.push(newSetting);
          })
        }
      } else {
        mainStudio = true;
      }
      this.studios = [...this.studios, {
        id: this.selectedItem.id,
        memberStatus: "member",
        name: this.selectedItem.name,
        partners: [],
        main: mainStudio
      }];
      this.isFilter = false;
      this.showStudioPopup = false;
    },
    togglePopup: async function (open, studio, photo) {
      if (!photo) {
        this.studioFilter = "";
        this.selectedItem = false;
        if (studio) {
          this.toAddStudios = this.fit20.studios.filter(studio => studio.active == true);

          this.toAddStudios = this.toAddStudios.filter(studio => !this.studios.some(existStudio => existStudio.id == studio.id));

        }
        this.showStudioPopup = !this.showStudioPopup;
      } else if (photo) {
        console.log("photo");
        this.showPhotoPopup = !this.showPhotoPopup;
        this.memberPhoto = this.fit20.storageBaseUrl + "/member/" + (this.member.photo ? this.member.id + ".png?generation=" + this.member.photo : "default.svg");
        this.newPhoto = false;
      }
    },
    openSelectDropdown: function () {
      this.isDropdownOpen = true;
    },
    selectAnItem(item) {
      this.studioFilter = item.name;
      this.selectedItem = item;
      this.isDropdownOpen = false;
    },
    changePhoto: function (e) {
      const file = e.target.files[0]; // Get the first selected file

      if (file) {
        // Use FileReader to read the selected file
        const reader = new FileReader();
        reader.onload = (e) => {
          this.memberPhoto = e.target.result; // Set the imageUrl to the data URL
          this.newPhoto = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    savePhoto: async function () {
      if (this.newPhoto) {
        console.log("there is a new photo");
        const formData = new FormData();
        formData.append('image', this.newPhoto);
        const res = await fetch(this.fit20.baseUrl + "/api/photos/member/" + this.member.id + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email, {
          method: 'POST',
          body: formData,
        });
        if (res.ok) {
          let photo = await res.json();

          this.admin_fit20.member.photo = photo;
          console.log("Upload photo done");
        } else {
          // Handle errors (e.g., show an error message)
          alert('Upload failed.');
          console.error('Upload failed.');
        }
      }
      console.log("save photo");
      // this.originalMemberPhoto = JSON.parse(JSON.stringify(this.newPhoto));
      // to do : change the photo in the members array.............................
      this.newPhoto = false;
      this.updated = true;
      this.showPhotoPopup = !this.showPhotoPopup;
    },
    // handleImageError(event) {
    //   event.target.src = this.defaultStudioPhoto; // Set the src to the default image path
    // },
  },
  watch: {
    'admin_fit20.member': {
      immediate: true, // This runs the watcher immediately on mount
      deep: true, // Watch for changes in nested properties
      async handler(newVal) {
        if (newVal && newVal.id && (!this.member.id || this.member.id != newVal.id || this.updated)) {
          this.member = { ...newVal };
          console.log("start update");
          if (this.admin) {
            this.studios = newVal.studios.map((item1) => ({
              ...item1,
              name: this.fit20.studios.find((item2) => item2.id == item1.id).name,
            }));
          }
          this.member.studios = JSON.parse(JSON.stringify(this.studios));
          this.memberStudios = this.studios.filter(studio => studio.memberStatus !== "exMember" && studio.memberStatus !== "exProspect");
          this.exMemberStudios = this.studios.filter(studio => studio.memberStatus == "exMember" || studio.memberStatus == "exProspect");

          this.member.startMembership = this.formatDate(this.member.startMembership);
          this.member.endMembership = this.formatDate(this.member.endMembership);
          this.member.birthDate = this.formatDate(this.member.birthDate);

          this.originalMember = JSON.parse(JSON.stringify(this.member))


          this.originalMember.height = this.originalMember.height ? Number(this.originalMember.height) : 0;
          this.originalMember.startMembership = this.formatDate(this.originalMember.startMembership);
          this.originalMember.endMembership = this.formatDate(this.originalMember.endMembership);
          this.originalMember.birthDate = this.formatDate(this.member.birthDate);
          this.lastWeight = newVal.measure.length > 0 ? newVal.measure[newVal.measure.length - 1].weight : 0;
          // this.machines = this.admin_fit20.machines.filter(machine => !this.studio.machines.some(studioMachine => studioMachine.id == machine.id));
          // this.studioMachines = this.admin_fit20.machines.filter(machine => this.studio.machines.some(studioMachine => studioMachine.id == machine.id));
          this.memberPhoto = this.fit20.storageBaseUrl + "/member/" + (this.member.photo ? this.member.id + ".png?generation=" + this.member.photo : "default.svg");
          this.originalMemberPhoto = this.fit20.storageBaseUrl + "/member/" + (this.member.photo ? this.member.id + ".png?generation=" + this.member.photo : "default.svg");
          // if (!this.member.id || this.member.id != newVal.id) {
          //   this.selectTab('#admin_studio_info');
          // }
          console.log("end update");
          this.updated = false;
        }
      }
    },
    member: {
      deep: true, // Watch for changes in nested properties
      handler(newVal) {

        if (isEqual(newVal, this.originalMember)) {
          console.log("equal");
          $('#cancelMember').removeClass("cancel-btn-active");
          $('#saveMember').removeClass("save-btn-active");
        } else {

          if (!$('#cancelMember').hasClass('cancel-btn-active')) {
            console.log("not equal");
            $('#cancelMember').addClass("cancel-btn-active");
            $('#saveMember').addClass("save-btn-active");
          }
        }
        // if (newVal.users.length != this.originalStudio.users.length) {
        //   if (isEqual(newVal.users, this.originalStudio))
        //     this.studioMangers = newVal.users.filter(user => user.role == "studio manager");
        //   this.trainers = newVal.users.filter(user => user.role == "trainer");
        // }
      }
    },
    'studios': {
      deep: true,
      handler(newVal) {
        this.memberStudios = newVal.filter(studio => studio.memberStatus !== "exMember" && studio.memberStatus !== "exProspect");
        this.exMemberStudios = newVal.filter(studio => studio.memberStatus == "exMember" || studio.memberStatus == "exProspect");
        if (!isEqual(newVal, this.member.studios)) {
          console.log("updated");
          this.member.studios = JSON.parse(JSON.stringify(newVal));

        }

        // this.studios = this.studios.filter(studio => !this.memberStudios.some(memberStudio => memberStudio.id == studio.id) && !this.exMemberStudios.some(exMemberStudio => exMemberStudio.id == studio.id));
      }
    },
    studioFilter: {
      deep: true, // Watch for changes in nested properties
      handler(newVal) {
        if (newVal.length > 0) {
          this.toAddStudios = [...this.fit20.studios].filter(studio => (studio.name).includes(newVal.toLowerCase().trim()) && studio.active == true && !this.studios.some(existStudio => existStudio.id == studio.id));

          this.isFilter = true;
        } else if (this.isFilter) {
          this.toAddStudios = [...this.fit20.studios];
          this.isFilter = false;
        }
      }
    },
    'member.height'(newValue) {
      // Ensure newValue is a number
      if (typeof newValue == 'string') {
        const numericValue = Number(newValue);
        if (!isNaN(numericValue)) {
          this.member.height = numericValue;
        } else {
          alert(this.$t('height-validation'));
        }
      }

    },
    //   'measure[measure.length - 1].weight'(newName, oldName) {
    // // Watcher for changes to the name property of the first item
    // console.log(`Name changed from "${oldName}" to "${newName}"`);
    //   },
    lastWeight(newVal) {
      console.log(typeof newVal);
      if (typeof newVal == 'string') {
        const numericValue = Number(newVal);
        if (!isNaN(numericValue)) {
          this.lastWeight = numericValue;
          this.newWeight.weight = numericValue;
          console.log(this.newWeight.weight);
          if (this.newWeight.weight != 0 && (this.originalMember.measure.length == 0 || this.newWeight.weight != this.originalMember.measure[this.originalMember.measure.length - 1].weight)) {
            $('#cancelMember').addClass("cancel-btn-active");
            $('#saveMember').addClass("save-btn-active");
          } else {
            $('#cancelMember').removeClass("cancel-btn-active");
            $('#saveMember').removeClass("save-btn-active");
          }
        } else {
          alert(this.$t('height-validation'));
        }
      }
    }
  }
};
</script>

<style>
.edit-studio-com.edit-studio-container {
  width: 100%;
  height: calc(100vh - 30px);
  /* Adjust as needed */
  overflow: auto;
}

.edit-studio-com .tab-content {
  padding-top: 15px;
}

.edit-studio-com .tab-content h2 {
  margin-left: 10px;
  margin-top: 20px;
}

.edit-studio-com .img-container img {
  border-radius: 15px;
  cursor: pointer;
  max-width: 150px;
}

.edit-studio-com .admin-studio-tab-pane {
  display: none;
  padding-bottom: 30px;
}

.edit-studio-com .form-container.active {
  display: flex !important;
  flex-wrap: wrap;
  justify-content: space-around;
}

.edit-studio-com .form-container div:not(.add-item) {
  width: calc(100% / 2 - 30px);
}

.edit-studio-com .form-container label {
  display: block;
}

.edit-studio-com .studio-users {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.edit-studio-com .users-col {
  width: calc(100%);
}

.edit-studio-com .studio-machines {
  width: 100%;
}

.edit-studio-com .ex-member-container {
  margin-top: 10px;
}

.edit-studio-com .ex-member-flex {
  width: 100% !important;
}

.edit-studio-com .ex-member-item {
  width: 80% !important;
  border: solid 1px var(--fit20-lighter-gray);
  padding: 5px 7px;
  border-radius: 10px;
  margin-bottom: 7px;
}

.edit-studio-com .ex-member-container img {
  margin-bottom: 7px;

}

.edit-studio-com .measure-div {
  position: relative;
}

.edit-studio-com .kg {
  position: absolute;
  right: 60px;
  bottom: 5px;
}
</style>
